module.exports = __webpack_public_path__ + "img/device_1015_1_select.f6868469.svg";